import { render } from "./VoucherItem.vue?vue&type=template&id=8ef7db56"
import script from "./VoucherItem.vue?vue&type=script&lang=js"
export * from "./VoucherItem.vue?vue&type=script&lang=js"

import "./VoucherItem.vue?vue&type=style&index=0&id=8ef7db56&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__